/**
 * Shared cache for the resolved post-auth route target.
 * Used by ResolvedHomeRoute (App.tsx) and cleared by Onboarding after completion.
 */
const _resolvedCache = new Map<string, string>();

export function getResolvedRoute(userId: string): string | undefined {
  return _resolvedCache.get(userId);
}

export function setResolvedRoute(userId: string, target: string): void {
  _resolvedCache.set(userId, target);
}

export function clearResolvedRoute(userId: string): void {
  _resolvedCache.delete(userId);
}

export function clearAllResolvedRoutes(): void {
  _resolvedCache.clear();
}
